<template>
  <div class="hello">
        <form v-on:submit.prevent="submitHandler()">
        <input type="text" v-on:change="changeHandler($event)" ref="input"  />
        <p></p>
        <input type="file" v-on:change="changeImage($event)" ref="file" />
        <p></p>
        <button>Submit Form</button>

        </form>
  </div>
</template>

<script>
export default {
  name: 'Form',
  data(){
  return  {
      "post" : "",
       "image": ""  
  }
  },
  methods: 
  {
        submitHandler: function ()
        {
            
            alert(this.post +" "+ this.image);
        },

        changeHandler: function (e)
        {
            let formInput = e.target.value;
            this.post = formInput;
        },

        changeImage: function(e)
        {
            //let imageInput = e.target.value;
            let file = e.target.files;
            let reader = new FileReader();
            reader.readAsDataURL(file[0]);
            reader.onload = (e) => {
                alert(e.target.result);
                this.image = e.target.result;
            }

            //this.setState({"image": imageInput});
            //console.log(e.target.files);
        }

  }
 
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
